<template>
  <aw-spring :desktop-size="10">
    <aw-breadcrumb-version2 :class="$style.breadcrumb" />
    <aw-cms-white-card
      mobile-negative-margin
      :class="$style.card"
    >
      <template #head>
        <div :class="$style.head">
          <lv-heading
            level="1"
            tag="h1"
            version2
          >
            {{ $awt('aw.pages.news.title') }}
          </lv-heading>
          <aw-simple-search-input
            v-model:search-text="searchText"
            :placeholder="$awt('aw.pages.news.search.placeholder')"
            :class="$style.headSearch"
            @search="changeKeyword"
            @clear="clearSearch"
          />
        </div>
      </template>
      <aw-aggregated-page-highlighted-carousel page-type="news" />
      <aw-aggregated-page-cards :key="keyword ?? undefined" :params="{ title: keyword }" page-type="news" />
    </aw-cms-white-card>
  </aw-spring>
</template>

<script setup lang="ts">
  import { onMounted, provide, ref } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwCmsWhiteCard from '~~/common/components/AwCmsWhiteCard.vue';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import AwSimpleSearchInput from '~~/common/components/Common/AwSimpleSearchInput.vue';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2.vue';
  import AwAggregatedPageCards from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageCards.vue';
  import AwAggregatedPageHighlightedCarousel from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageHighlightedCarousel.vue';
  import { defineI18nRoute } from '#i18n';

  defineOptions({
    name: 'NewsPage',
  });

  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });
  const { $awt } = useNuxtApp();
  provide('getRowIndexById', () => 0);

  const searchText = ref('');
  const keyword = ref<string | null>(null);

  const changeKeyword = (newKeyword: string) => {
    keyword.value = newKeyword;
  };
  const clearSearch = () => {
    keyword.value = '';
  };

  onMounted(() => {
    const breadcrumbStore = useBreadcrumbStore();
    breadcrumbStore.setBreadcrumbs([
      {
        token: $awt('aw.common.category.home'),
        to: '/',
        disabled: false,
      },
      {
        token: $awt('aw.pages.news.title'),
        to: 'news',
        disabled: true,
      },
    ]);
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/news',
      hu: '/hirek',
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.head {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @include tablet(min) {
    flex-direction: row;
    justify-content: space-between;
  }

  &Search {
    width: 100%;
    @include tablet(min) {
      width: 50%;
      max-width: 520px;
    }
  }
}

.breadcrumb {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}

.card {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}
</style>
